// SlideProgressBar — segmented progress indicator (Instagram Stories style)

/**
 * @param {Object} props
 * @param {number} props.current - Current slide index (0-based)
 * @param {number} props.total - Total number of slides
 * @param {string} props.accentColor - CSS colour for active segments
 */
export default function SlideProgressBar({ current, total, accentColor }) {
  if (total <= 1) return null

  return (
    <div className="slide-progress">
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          className={`slide-progress__segment ${i <= current ? 'slide-progress__segment--active' : ''}`}
          style={i <= current ? { backgroundColor: accentColor } : undefined}
        />
      ))}
    </div>
  )
}
